import {GroupDefinition} from "../models/grid-fields/group-definition";
import { FormGridField } from "../components/FormGrid";
import { ButtonSelectorDefinition } from "../models/grid-fields/button-selector-definition";
import { CheckboxDefinition } from "../models/grid-fields/checkbox-definition";
import { NumberInputDefinition } from "../models/grid-fields/number-input-definition";
import { SelectMenuDefinition } from "../models/grid-fields/select-menu-definition";
import { TextInputDefinition } from "../models/grid-fields/text-input-definition";
import { TwoPanelSelectorDefinition } from "../models/grid-fields/two-panel-selector-definition";
import { HiddenInputDefinition } from "../models/grid-fields/hidden-input-definition";
import { TextAreaDefinition } from "../models/grid-fields/text-area-definition";
import { DateInputDefinition } from "../models/grid-fields/date-input-definition";
import { BetJackpotArrayDefinition } from "../models/grid-fields/bet-jackpot-array-definition";
import { BulletsSelectorDefinition } from "../models/grid-fields/bullets-selector-definition";

export interface FormDefinition {
    [key: string]: {
        definition:
            | ButtonSelectorDefinition
            | CheckboxDefinition
            | NumberInputDefinition
            | SelectMenuDefinition
            | TextInputDefinition
            | TextAreaDefinition
            | HiddenInputDefinition
            | TwoPanelSelectorDefinition
            | DateInputDefinition
            | GroupDefinition
            | BetJackpotArrayDefinition
            | BulletsSelectorDefinition;
        order: number;
        inherited?: boolean;
    };
}

export default function buildFormGridFields(
    schema,
    formDefinition: FormDefinition,
    inheritedSchema?: any,
    extraRequiredFields?: string[]
): FormGridField[] {
    const gridFields: FormGridField[] = [];
    const fieldDefinitions = [];

    for (let field in formDefinition) {
        fieldDefinitions.push(formDefinition[field]);
    }

    fieldDefinitions.sort((a, b) => {
        return a.order > b.order ? 1 : a.order < b.order ? -1 : 0;
    });

    const newSchema =
        extraRequiredFields != undefined
            ? changeRequiredFromSchema(schema, extraRequiredFields)
            : schema;

    fieldDefinitions.forEach(fieldDefinition => {
        gridFields.push(
            fieldDefinition.definition.buildFormGridField(
                fieldDefinition.inherited ? inheritedSchema.items : newSchema
            )
        );
    });

    return gridFields;
}

const changeRequiredFromSchema = (schema, extraRequiredFields) => {
    let newSchema = { ...schema };
    newSchema.required = newSchema.required.concat(extraRequiredFields);
    return newSchema;
};
